import React, {useLayoutEffect, useRef, useState} from 'react';

interface IPathIconProps {
	path: string;
	size: number;
	colors: {
		fillColor: string | undefined;
		lineColor: string | undefined;
	};
	svgStyle: React.CSSProperties;
}

/** Path-иконка: измеряем bbox, центрируем и масштабируем в size×size (path из PathMap часто рисуется в углу). */
const PathIcon: React.FC<IPathIconProps> = ({path, size, colors, svgStyle}) => {
	const gRef = useRef<SVGGElement | null>(null);
	const [transform, setTransform] = useState('');

	useLayoutEffect(() => {
		const g = gRef.current;
		if (!g) return;
		const pathEl = g.querySelector('path');
		if (!pathEl) return;
		try {
			const bbox = pathEl.getBBox();
			if (bbox.width <= 0 || bbox.height <= 0) return;
			const pad = 1;
			const scale = Math.min((size - pad * 2) / bbox.width, (size - pad * 2) / bbox.height);
			const cx = bbox.x + bbox.width / 2;
			const cy = bbox.y + bbox.height / 2;

			setTransform(
				`translate(${size / 2},${size / 2}) scale(${scale}) translate(${-cx},${-cy})`
			);
		} catch {
			// getBBox can fail in some envs
		}
	}, [path, size]);

	return (
		<svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={svgStyle}>
			<g ref={gRef} transform={transform}>
				<path
					d={path}
					fill={colors.fillColor === 'none' ? 'none' : colors.fillColor}
					stroke={colors.lineColor}
					strokeWidth={0.5}
				/>
			</g>
		</svg>
	);
};

export default PathIcon;
